function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

export default {
  data: function data() {
    return {
      topScrollHandler: null,
      bottomScrollHandler: null,
      nextPageUrl: null,
      prevPageUrl: null,
      request: null,
      infiniteScroll: null
    };
  },
  // computed: {
  //   bottomAnchorStyles() {
  //     return {
  //       display: this.infiniteScroll && this.nextPageUrl ? "block" : "none"
  //     };
  //   }
  // },
  methods: {
    enableInfiniteScrollIfApplicable: function enableInfiniteScrollIfApplicable() {
      var _this = this;

      this.$removeViewportChangeListeners(this.topScrollHandler);
      this.$removeViewportChangeListeners(this.bottomScrollHandler);
      var prevPage = this.spec.prevPage || {};
      var nextPage = this.spec.nextPage || {};
      this.infiniteScroll = nextPage.autoload == "asNeeded" || prevPage.autoload == "asNeeded";
      var onScrollToBottom = this.spec.onScrollToBottom;
      var onScrollToTop = this.spec.onScrollToTop; // Reset state for reuse.

      this.nextPageUrl = null;
      this.prevPageUrl = null;

      if (this.infiniteScroll) {
        this.nextPageUrl = nextPage.url;
        this.prevPageUrl = prevPage.url;
      } // Avoid executing the scroll actions on page load.


      setTimeout(function () {
        if (_this.nextPageUrl || onScrollToBottom) {
          _this._registerBottomScroll(onScrollToBottom);
        }

        if (_this.prevPageUrl || onScrollToTop) {
          _this._registerTopScroll(onScrollToTop);
        }
      }, 1000);
    },
    _registerTopScroll: function _registerTopScroll(onScrollToTop) {
      var _this2 = this;

      this.topScrollHandler = this.$onVisibilityChange(this.$refs.topAnchor, function (el, visible) {
        if (visible) {
          _this2._handleTopScroll(onScrollToTop);
        }
      });
      this.$addViewportChangeListeners(this.topScrollHandler);
    },
    _handleTopScroll: function _handleTopScroll(onScrollToTop) {
      var _this3 = this;

      if (this.prevPageUrl) {
        this.request = Utils.http.execute({
          url: this.prevPageUrl
        }, "GET", this, function (response) {
          var prevPage = response.prevPage;

          if (_this3.$type.isObject(prevPage)) {
            _this3.prevPageUrl = response.prevPage.url;
          } else {
            _this3.prevPageUrl = null;
          }

          var previousFirstRowIndex = null;

          var _iterator = _createForOfIteratorHelper(response.sections.entries()),
              _step;

          try {
            var _loop = function _loop() {
              var _ref = _step.value;
              _ref2 = _slicedToArray(_ref, 2);
              var index = _ref2[0];
              var prependedSection = _ref2[1];
              var section = _this3.sections[index];
              Utils.type.ifArray(prependedSection.rows, function (rows) {
                // Get the number of rows prepended to the top section
                if (index == 0) {
                  previousFirstRowIndex = rows.length;
                }

                var _iterator2 = _createForOfIteratorHelper(rows),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var row = _step2.value;
                    section.rows.unshift(row);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              });

              _this3._updateScrollAfterPrepending(previousFirstRowIndex);
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ref2;

              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          Utils.history.updatePage();
        });
      }

      GLib.action.execute(onScrollToTop, this);
    },
    _updateScrollAfterPrepending: function _updateScrollAfterPrepending(previousFirstRowIndex) {
      var _this4 = this;

      // Scroll back to where the position was before the prepending.
      if (previousFirstRowIndex) {
        // Pre-record the height to get an accurate value
        var anchorHeight = this.$refs.topAnchor.clientHeight;
        this.$nextTick(function () {
          var prependedBottomElement = _this4.$refs["row_0_".concat(previousFirstRowIndex - 1)][0];

          var top = prependedBottomElement.offsetTop + prependedBottomElement.clientHeight - anchorHeight;
          var pageBody = Utils.history._pageBody;
          pageBody.scrollTop = top;
        });
      }
    },
    _registerBottomScroll: function _registerBottomScroll(onScrollToBottom) {
      var _this5 = this;

      this.bottomScrollHandler = this.$onVisibilityChange(this.$refs.bottomAnchor, function (el, visible) {
        if (visible) {
          _this5._handleBottomScroll(onScrollToBottom);
        }
      });
      this.$addViewportChangeListeners(this.bottomScrollHandler);
    },
    _handleBottomScroll: function _handleBottomScroll(onScrollToBottom) {
      var _this6 = this;

      if (this.nextPageUrl) {
        this.request = Utils.http.execute({
          url: this.nextPageUrl
        }, "GET", this, function (response) {
          var nextPage = response.nextPage;

          if (_this6.$type.isObject(nextPage)) {
            _this6.nextPageUrl = response.nextPage.url;
          } else {
            _this6.nextPageUrl = null;
          }

          var _iterator3 = _createForOfIteratorHelper(response.sections),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var section = _step3.value;

              _this6.sections.push(section);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          Utils.history.updatePage();
        });
      }

      GLib.action.execute(onScrollToBottom, this);
    },
    autoloadAll: function autoloadAll(nextPage) {
      var vm = this;

      if (!this.$type.isObject(nextPage)) {
        return;
      }

      if (nextPage.autoload !== "all") {
        return;
      }

      var nextPageUrl = nextPage.url;
      this.request = Utils.http.execute({
        url: nextPageUrl
      }, "GET", vm, function (response) {
        var _iterator4 = _createForOfIteratorHelper(response.sections),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var section = _step4.value;
            vm.sections.push(section);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        vm.autoloadAll(response.nextPage);
      });
    },
    cancelAutoloadRequest: function cancelAutoloadRequest() {
      // Avoid old data coming in when this component gets reused.
      if (this.request) {
        this.request.cancel();
      }
    }
  }
};